module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hant/2-deb858851f3aea7e556a30abebbe4038.jpg";